export default __webpack_public_path__ + "static/media/github-icon.b37d01ff.svg";